<template>
  <div
    class="font-primary font-medium text-[17px] leading-[18px] text-gray-800 pb-6 border-b border-[#DFDFDF]"
  >
    Account management
  </div>

  <SettingsRow>
    <template #left><div>Delete account</div></template>

    <template #right>
      <div
        v-if="user"
        class="flex items-center cursor-pointer"
        @click="emit('delete')"
      >
        <Icon name="Alert" :size="18" class="stroke-red-700 mr-2" />
        <div class="font-medium text-red-700">Delete</div>
      </div>
      <Skeleton v-else class="w-[80px] h-[18px]" />
    </template>
  </SettingsRow>
</template>

<script setup lang="ts">
import SettingsRow from '@/features/settings/components/SettingsRow.vue'
import { Icon, Skeleton } from '@dacr/ui'
import type { UserFieldsFragment } from '@/shared/graphql/legacy/generated'

defineProps<{
  user: UserFieldsFragment | null
}>()

const emit = defineEmits<{
  (e: 'delete'): void
}>()
</script>
